<template lang="pug">
    .address(:class="{ 'hide-autocomplete-popper': numberOfFilledFields < 2 }")
        el-row.root-row.no-padding(:gutter="40")
            el-col.map-col(:xl="12" :lg="24")
                .map-container(:class="{ show: showMap, deleted: data.deleted }")
                    //- :key="`mapbox-${showDefaultSwitches ? 'extended' : 'regular'}`"
                    MglMap(
                        ref="mapbox"
                        :accessToken="accessToken"
                        :mapStyle="mapStyle"
                        :center="center"
                        :zoom="zoom"
                        :max-zoom="18"
                        :min-zoom="2.5"
                        :interactive="false"
                        @load="mapBoxLoaded"
                    )
                        MglMarker(
                            v-if="marker"
                            :key="markerColor"
                            :coordinates="marker"
                            :color="markerColor"
                            anchor="bottom"
                        )
                            i.el-icon-fa-map-marker-alt.fas(slot="marker" :style="{ color: markerColor }")
                            //- svg(xmlns="http://www.w3.org/2000/svg" viewbox="0 0 384 512")
                            //-     g.fa-group
                            //-         path.fa-secondary(fill="currentColor" d="M192 0C86 0 0 86 0 192c0 77.41 27 99 172.27 309.67a24 24 0 0 0 39.46 0C357 291 384 269.41 384 192 384 86 298 0 192 0zm0 288a96 96 0 1 1 96-96 96 96 0 0 1-96 96z")
                            //-         path.fa-primary(fill="currentColor" d="M192 256a64 64 0 1 1 64-64 64 64 0 0 1-64 64z")
            el-col(:xl="12" :lg="24")
                el-row.no-padding(:gutter="20")
                    el-col(:md="6")
                        el-form-item(:label="$t('Gender')" :prop="validationPath + '.gender'")
                            el-select.is-full-width(
                                :disabled="data.deleted"
                                clearable
                                placeholder=""
                                v-model="gender"
                            )
                                el-option(:label="$t('Mr.')" value="M")
                                el-option(:label="$t('Mrs.')" value="F")
                                el-option(:label="$t('Undefined')" value="X")
                    el-col(:md="9")
                        el-form-item(:label="$t('First name')" :prop="validationPath + '.first_name'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="firstName"
                                maxlength="255"
                                show-word-limit
                            )
                    el-col(:md="9")
                        el-form-item(:label="$t('Last name')" :prop="validationPath + '.last_name'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="lastName"
                                maxlength="255"
                                show-word-limit
                            )
                el-row.no-padding(:gutter="20")
                    el-col( :md="12")
                        el-form-item(:label="$t('Email')" :prop="validationPath + '.email'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="email"
                                maxlength="255"
                                show-word-limit
                            )
                    el-col( :md="12")
                        el-form-item(:label="$t('Phone')" :prop="validationPath + '.phone'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="phone"
                                maxlength="255"
                                show-word-limit
                            )
                el-row.no-padding(:gutter="20")
                    el-col(:lg="16" :md="16")
                        el-form-item(:label="$t('Company')" :prop="validationPath + '.company'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="company"
                                :maxlength="255"
                                show-word-limit
                            )
                    el-col(:lg="8" :md="8")
                        el-form-item(:label="$t('Company addition')" :prop="validationPath + '.company_addition'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="companyAddition"
                                :maxlength="255"
                                show-word-limit
                            )

                el-form-item(:label="$t('Street')" :prop="validationPath + '.street'")
                    el-input.is-full-width(
                        :disabled="data.deleted"
                        v-model="street"
                        @change="refreshMarker"
                        :maxlength="255"
                        show-word-limit
                    )
                el-row.no-padding(:gutter="20")
                    el-col(:lg="8" :md="8")
                        el-form-item(:label="$t('Zipcode')" :prop="validationPath + '.zipcode'")
                            el-autocomplete.is-full-width(
                                :disabled="data.deleted"
                                v-model="zipcode"
                                v-bind="props"
                                :debounce="300"
                                :fetch-suggestions="findAddresses"
                                @select="selectAddress"
                                @change="refreshMarker"
                                :maxlength="255"
                                show-word-limit
                            )
                    el-col(:lg="16" :md="16")
                        el-form-item(:label="$t('City')" :prop="validationPath + '.city'")
                            el-autocomplete.is-full-width(
                                :disabled="data.deleted"
                                v-model="city"
                                v-bind="props"
                                :debounce="300"
                                :fetch-suggestions="findAddresses"
                                @select="selectAddress"
                                @change="refreshMarker"
                                :maxlength="255"
                                show-word-limit
                            )
                el-form-item(:label="$t('Country')" :prop="validationPath + '.country'")
                    el-select.is-full-width(
                        :disabled="data.deleted"
                        placeholder=""
                        filterable
                        clearable
                        v-model="country"
                        @change="refreshMarker"
                        autocomplete="no-fill"
                    )
                        el-option(v-for="(label, value) in countries" :key="value" :label="label" :value="value")

                el-row.no-padding(:gutter="20")
                    el-col(:md="12")
                        el-form-item(:label="$t('VAT ID')" :prop="validationPath + '.tax_id'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="taxId"
                                :maxlength="255"
                                show-word-limit
                            )
                    el-col(:md="12")
                        el-form-item(:label="$t('Tax number')" :prop="validationPath + '.tax_nr'")
                            el-input(
                                :disabled="data.deleted"
                                v-model="taxNr"
                                :maxlength="255"
                                show-word-limit
                            )
                el-form-item(:label="$t('URL')" :prop="validationPath + '.url'")
                    el-input(
                        :disabled="data.deleted"
                        v-model="url"
                        :maxlength="255"
                        show-word-limit
                    )
                el-form-item(:label="$t('Line 1')" :prop="validationPath + '.line_1'")
                    el-input(
                        :disabled="data.deleted"
                        v-model="line1"
                        :maxlength="255"
                        show-word-limit
                    )
                el-form-item(:label="$t('Line 2')" :prop="validationPath + '.line_2'")
                    el-input(
                        :disabled="data.deleted"
                        v-model="line2"
                        :maxlength="255"
                        show-word-limit
                    )
                el-form-item(:label="$t('Line 3')" :prop="validationPath + '.line_3'")
                    el-input(
                        :disabled="data.deleted"
                        v-model="line3"
                        :maxlength="255"
                        show-word-limit
                    )

                .flex-row
                    el-form-item.grow.default-switches(v-if="showDefaultSwitches" :prop="validationPath + '.defaultSwitches'")
                        el-switch(
                            :disabled="data.deleted"
                            :active-text="$t('Default Billing')"
                            v-model="defaultBilling"
                        )
                        el-switch(
                            :disabled="data.deleted"
                            :active-text="$t('Default Shipping')"
                            v-model="defaultShipping"
                        )
                    el-form-item(v-if="showPublicSwitch" :prop="validationPath + '.public'")
                        el-switch(
                            :disabled="data.deleted"
                            :active-text="$t('Public')"
                            v-model="public"
                        )
</template>

<i18n>
{
    "de": {
        "Gender": "Geschlecht",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Phone": "Telefon",
        "Street": "Straße",
        "Zipcode": "PLZ",
        "City": "Ort",
        "Country": "Land",
        "Company": "Firma",
        "Company addition": "Firmenzusatz",
        "Default Billing": "Standard Rechnungsadresse",
        "Default Shipping": "Standard Versandadresse",
        "Public": "Öffentlich",
        "VAT ID": "USt-IdNr.",
        "Tax number": "Steuernummer",
        "Line 1": "Zeile 1",
        "Line 2": "Zeile 2",
        "Line 3": "Zeile 3",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt"
    }
}
</i18n>

<script>
import axios from 'axios'
import Mapbox from 'mapbox-gl'
import MultiTouch from 'mapbox-gl-multitouch'
import { MglMap, MglMarker } from 'vue-mapbox'
import { getTime, startOfDay } from 'date-fns'
import _ from 'lodash'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import { useRestrictedAreaMemberStore } from '@/stores'
import { country } from '@/filters'

export default {
    name: 'Address',
    data() {
        return {
            accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
            germany: [10.4515, 51.1657],
            center: [10.4515, 51.1657],
            zoom: 3.6,
            showMap: false,
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        showDefaultSwitches: {
            type: Boolean,
            default: false,
        },
        showPublicSwitch: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        MglMap,
        MglMarker
    },
    watch: {
        marker(fresh, old) {
            let zoom = 3.6
            let center = this.germany

            if (fresh && fresh !== old) {
                zoom = 14
                center = fresh
            }

            if (this.$refs.mapbox && this.$refs.mapbox.map) {
                this.$refs.mapbox.map.flyTo({
                    center,
                    zoom,
                    essential: true,
                    duration: 0,
                })
            }
        },
        showDefaultSwitches(fresh, old) {
            if (fresh !== old && this.$refs.mapbox && this.$refs.mapbox.map) {
                this.$nextTick(() => {
                    this.$refs.mapbox.map.resize()
                    this.fixMapCenterAndZoom()
                });
            }
        }
    },
    computed: {
        memberStore() {
            return useRestrictedAreaMemberStore()
        },
        numberOfFilledFields() {
            let number = 0

            if (this.street && this.street.length >= 2) ++ number
            if (this.zipcode && this.zipcode.length >= 2) ++ number
            if (this.city && this.city.length >= 2) ++ number
            if (this.country) ++ number

            return number
        },
        props() {
            let props = {
                'trigger-on-focus': false,
                'hide-loading': true,
                'popper-append-to-body': false,
            }

            if (this.numberOfFilledFields >= 2) {
                props = {
                    'trigger-on-focus': true,
                    'hide-loading': false,
                    'popper-append-to-body': true,
                }
            }

            return props
        },
        validationPath() {
            return `addresses.${this.index}`
        },
        countries() {
            return countries.getNames('de')
        },
        // center() {
        //     let center = this.germany
        //     if (this.marker) center = this.marker
        //     return center
        // },
        // zoom() {
        //     let zoom = 3.6
        //     if (this.marker) zoom = 14
        //     return zoom
        // },
        mapStyle() {
            let style = 'mapbox://styles/vanameland/ckclxo9az13jn1io5gnwr9tjr'
            if (this.data.deleted) style = 'mapbox://styles/vanameland/ckcol2tqs0buw1ill8ibq16d7'
            return style
        },
        marker() {
            let marker = undefined
            // if (this.data.latitude && this.data.longitude && ! this.data.deleted)
            if (this.street && this.city && this.data.latitude && this.data.longitude) {
                marker = [this.data.longitude, this.data.latitude]
            }
            return marker
        },
        markerColor() {
            let color = '#be1521'
            if (this.data.deleted) color = '#dedede'
            return color
        },
        gender: {
            get() {
                return _.get(this.data, 'gender', '')
            },
            set(value) {
                this.memberStore.setFormAddressGender({ i: this.index, value })
            }
        },
        firstName: {
            get() {
                return _.get(this.data, 'first_name', '')
            },
            set(value) {
                this.memberStore.setFormAddressFirstName({ i: this.index, value })
            }
        },
        lastName: {
            get() {
                return _.get(this.data, 'last_name', '')
            },
            set(value) {
                this.memberStore.setFormAddressLastName({ i: this.index, value })
            }
        },
        email: {
            get() {
                return _.get(this.data, 'email', '')
            },
            set(value) {
                this.memberStore.setFormAddressEmail({ i: this.index, value })
            }
        },
        phone: {
            get() {
                return _.get(this.data, 'phone', '')
            },
            set(value) {
                this.memberStore.setFormAddressPhone({ i: this.index, value })
            }
        },
        street: {
            get() {
                return this.data.street
            },
            set(value) {
                this.memberStore.setFormAddressStreet({ i: this.index, value })
                if (!value) this.setMarker(null, null)
            }
        },
        zipcode: {
            get() {
                return this.data.zipcode
            },
            set(value) {
                this.memberStore.setFormAddressZipcode({ i: this.index, value })
                if (!value && !this.data.city) this.setMarker(null, null)
            }
        },
        city: {
            get() {
                return this.data.city
            },
            set(value) {
                this.memberStore.setFormAddressCity({ i: this.index, value })
                if (!value && !this.data.zipcode) this.setMarker(null, null)
            }
        },
        country: {
            get() {
                return this.data.country
            },
            set(value) {
                this.memberStore.setFormAddressCountry({ i: this.index, value })
            }
        },
        company: {
            get() {
                return this.data.company
            },
            set(value) {
                this.memberStore.setFormAddressCompany({ i: this.index, value })
            }
        },
        companyAddition: {
            get() {
                return this.data.company_addition
            },
            set(value) {
                this.memberStore.setFormAddressCompanyAddition({ i: this.index, value })
            }
        },
        taxId: {
            get() {
                return this.data.tax_id
            },
            set(value) {
                this.memberStore.setFormAddressTaxId({ i: this.index, value })
            }
        },
        taxNr: {
            get() {
                return this.data.tax_nr
            },
            set(value) {
                this.memberStore.setFormAddressTaxNr({ i: this.index, value })
            }
        },
        url: {
            get() {
                return this.data.url
            },
            set(value) {
                this.memberStore.setFormAddressUrl({ i: this.index, value })
            }
        },
        line1: {
            get() {
                return this.data.line_1
            },
            set(value) {
                this.memberStore.setFormAddressLine1({ i: this.index, value })
            }
        },
        line2: {
            get() {
                return this.data.line_2
            },
            set(value) {
                this.memberStore.setFormAddressLine2({ i: this.index, value })
            }
        },
        line3: {
            get() {
                return this.data.line_3
            },
            set(value) {
                this.memberStore.setFormAddressLine3({ i: this.index, value })
            }
        },
        public: {
            get() {
                return this.data.public
            },
            set(value) {
                this.memberStore.setFormAddressPublic({ i: this.index, value })
            }
        },
        defaultBilling: {
            get() {
                return this.data.default_billing
            },
            set(value) {
                if (value) this.memberStore.setFormDefaultBilling({ i: this.index, value })
            }
        },
        defaultShipping: {
            get() {
                return this.data.default_shipping
            },
            set(value) {
                if (value) this.memberStore.setFormDefaultShipping({ i: this.index, value })
            }
        },
    },
    methods: {
        findAddresses(query, cb) {
            if (this.numberOfFilledFields >= 2) {
                const language = 'de'
                const timestamp = getTime(startOfDay(new Date()))
                const proximity = this.germany.join(',')

                let parts = []
                if (this.street && this.street.length >= 2) parts.push(this.street)
                if (this.zipcode && this.zipcode.length >= 2) parts.push(this.zipcode)
                if (this.city && this.city.length >= 2) parts.push(this.city)
                if (this.country) parts.push(country(this.country, language))
                // else parts.push(country('de', language))

                query = parts.join(' ')

                axios
                    // &languageMode=strict
                    // &types=postcode,address
                    .get(`${process.env.VUE_APP_MAPBOX_GOECODING_ENDPOINT}${query}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}&cachebuster=${timestamp}&autocomplete=true&language=${language}&types=postcode,address&proximity=${proximity}`)
                    .then(({ data }) => {
                        let suggestions = []
                        if (data && data.features && data.features.length) {
                            data.features.forEach(feature => {
                                if (feature.place_name
                                    // && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                    && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                    && feature.relevance >= 0.5
                                ) {
                                    suggestions.push({ value: feature.place_name, data: feature })
                                }
                            })
                        }

                        cb(suggestions)
                    })
                    // eslint-disable-next-line
                    .catch(err => cb(null));
            }
        },
        refreshMarker: _.debounce(function(value) { // function scope is needed here
            if (!value) return

            this.findAddresses('', items => {
                if (items && items.length) {
                    const match = items[0]
                    if (match.data.relevance > 0.95) {
                        this.selectAddress(match)
                    } else if (match.data.relevance > 0.7) {
                        if (match.data && match.data.center) {
                            this.setMarker(match.data.center[0], match.data.center[1])
                        }
                    } else {
                        this.setMarker(null, null)
                    }
                }
            })
        }, 300),
        setMarker(longitude, latitude) {
            if (!longitude || !latitude) this.center = this.germany
            else this.center = [longitude, latitude]

            this.memberStore.setFormLatitude({ i: this.index, value: latitude })
            this.memberStore.setFormLongitude({ i: this.index, value: longitude })
        },
        fixMapCenterAndZoom() {
            if (this.numberOfFilledFields === 4 && ! this.marker) {
                this.refreshMarker()
            } else if (this.marker) {
                this.center = this.marker
                this.zoom = 14
            }
        },
        selectAddress(address) {
            if (address.data && address.data.context && address.data.context.length) {
                if (address.data.id.startsWith('address')) {
                    // find street
                    if (address.data.address) this.street = _.trim(`${address.data.text} ${address.data.address}`)
                    else this.street = address.data.text
                } else if (address.data.id.startsWith('postcode')) {
                    // find zipcode
                    this.zipcode = address.data.text
                }

                address.data.context.forEach(entry => {
                    if (entry.id.startsWith('postcode')) {
                        // find zipcode
                        this.zipcode = entry.text
                    } else if (entry.id.startsWith('place')) {
                        // find city
                        this.city = entry.text
                    } else if (entry.id.startsWith('country')) {
                        // find country
                        this.country = countries.getAlpha2Code(entry.text, 'de')
                    }
                })

                if (address.data.id.startsWith('address')) {
                    this.memberStore.setFormLongitude({ i: this.index, value: address.data.center[0] })
                    this.memberStore.setFormLatitude({ i: this.index, value: address.data.center[1] })

                    // this.center = this.marker
                    // this.zoom = 14

                    this.$refs.mapbox.map.flyTo({
                        center: this.marker,
                        essential: true,
                        zoom: 14,
                        duration: 0,
                    })
                }
            }
        },
        async mapBoxLoaded(event) {
            // const language = 'de'

            let map = event.map
            // map.setLayoutProperty('country-label', 'text-field', [ 'get', 'name_' + language ]);

            this.fixMapCenterAndZoom()
            setTimeout(() => this.showMap = true, 300);

            map.addControl(new MultiTouch());
        }
    },
    created() {
        // We need to set mapbox-gl library here in order to use it in template

        this.mapbox = Mapbox;

        // const language = 'de'
        // this.$refs.mapbox.map.setLayoutProperty('country-label', 'text-field', [
        //     'get',
        //     'name_' + language
        // ])
    },
}

</script>


<style lang="sass" scoped>
.default-switches .el-switch
    margin-right: 40px
.mgl-map-wrapper
    min-height: 303px
.hide-autocomplete-popper
    ::v-deep
        .el-autocomplete-suggestion
            display: none !important
.map-container
    background: $color-skeleton
    border-radius: 4px
    height: 100%
    .mgl-map-wrapper
        opacity: 0
        transition: opacity .3s ease
    &.show
        .mgl-map-wrapper
            opacity: 1
    .mapboxgl-marker
        font-size: 2rem
        line-height: 2rem
        height: 2rem
        &:after
            content: ''
            position: absolute
            width: 10px
            height: 0px
            bottom: -2px
            left: calc(50% - 5px)
            box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
    &.deleted
        .mapboxgl-marker:after
            box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1)

.el-row.root-row
    +res(xl)
        display: flex
        flex-direction: row-reverse
.map-col
    margin-bottom: 20px
</style>
